"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageEngagementDashboardPopover = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PageEngagementPopover_1 = require("Common/Engagement/PageEngagementPopover/PageEngagementPopover");
var Engagement_1 = require("Common/Engagement");
var PageEngagementDashboardPopover = function (_a) {
    var projectStore = _a.projectStore, isAdmin = _a.isAdmin, canEditProject = _a.canEditProject, onAnalyticsClick = _a.onAnalyticsClick, isOpen = _a.isOpen, onPopoverChange = _a.onPopoverChange;
    var pageId = projectStore._id, initialEngagement = projectStore.engagement, status = projectStore.status;
    var engagementPopoverState = (0, PageEngagementPopover_1.useCommonPageEngagementPopoverState)(pageId, initialEngagement);
    var engagement = engagementPopoverState.engagement, isCalculating = engagementPopoverState.isCalculating, isRefreshing = engagementPopoverState.isRefreshing;
    var showCalculatingIcon = isCalculating || isRefreshing;
    return (react_1.default.createElement(kaleidoscope_1.Popover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: (0, Engagement_1.getEngagementLevelDisplayName)(engagement.level, isCalculating) },
            react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { icon: react_1.default.createElement(Engagement_1.EngagementIcon, { engagementLevel: engagement.level, isCalculating: showCalculatingIcon, key: "".concat(engagement.level, "-").concat(showCalculatingIcon) }), size: kaleidoscope_1.ButtonSize.Small })))); }, onClickStopPropagation: true, caret: true, isOpen: isOpen, onChange: onPopoverChange, autoStack: true, position: kaleidoscope_1.PopoverPosition.Bottom },
        react_1.default.createElement(PageEngagementPopover_1.PageEngagementPopoverContent, __assign({ pageId: pageId, pageStatus: status, canEditProject: canEditProject, isAdmin: isAdmin, onAnalyticsClick: onAnalyticsClick }, engagementPopoverState))));
};
exports.PageEngagementDashboardPopover = PageEngagementDashboardPopover;
